module.exports = __webpack_public_path__ + "static/media/andarbahar.4b7e340e.webp";